import { Controller } from "@hotwired/stimulus"

// 초대 코드 관리 페이지용 컨트롤러
export default class extends Controller {
  static targets = ["modal"]
  static values = {
    newUrl: String
  }

  // 새 코드 발급 모달 열기
  openNewModal(event) {
    event.preventDefault()

    if (!this.hasModalTarget) return

    // 재발급인 경우 기존 코드 ID를 URL에 추가
    const replaceId = event.currentTarget.dataset.replaceId
    let url = this.newUrlValue
    if (replaceId) {
      url = `${url}?replace_id=${replaceId}`
    }

    // Turbo Frame으로 내용 로드
    const frame = this.modalTarget.querySelector('turbo-frame')
    if (frame) {
      frame.src = url
      frame.reload()
    }

    // modal 컨트롤러의 open 메서드 호출
    const modalController = this.application.getControllerForElementAndIdentifier(this.modalTarget, 'modal')
    if (modalController) {
      modalController.open()
    }
  }
}
